<div class="mb-4">
    <div *ngFor="let control of controls | keyvalue" style="font-size:small">
        <div *ngIf="control.value.errors" class="validationErrors" [@validationErrorAnimation]>
            <span class="control">{{control.key | uppercase | translate}}:</span>
            <span *ngFor="let error of control.value.errors | keyvalue">
                {{'VALIDATION.'+error.key | uppercase | translate}}
            </span>
        </div>
    </div>
</div>